import React, { useState, useRef } from 'react';
import {
	Typography,
	InputGroup,
	Button,
	Div,
	Tag,
} from '@icecreamsocial/components';
import { AddNoteIcon } from '../SupportedIcons';

export const PersonalMessageToggle = ({
	openByDefault = false,
	defaultMessage = '',
	placeholder = "Hey friends, you're going to love this...",
	maxLength = 100,
	onUpdate = () => {},
	...rest
}) => {
	const [isOpen, setIsOpen] = useState(openByDefault);
	const [message, setMessage] = useState(defaultMessage);

	const handleMessageUpdate = (e) => {
		setMessage(e.target.value);
		if (message.length <= maxLength) onUpdate(e.target.value);
	};

	const handleRemove = () => {
		setMessage('');
		setIsOpen(false);
		onUpdate('');
	};

	return (
		<>
			<Div
				display="flex"
				alignItems="center"
				justifyContent="space-between"
				marginTop="xlg"
				{...rest}
			>
				<Button
					onClick={() => {
						setIsOpen(!isOpen);
					}}
					paddingLeft="0"
					border="0"
					shadow="none"
					hoverShadow="none"
					backgroundColor="transparent"
					display="flex"
					alignItems="center"
					style={{ gap: '8px' }}
				>
					<AddNoteIcon textColor="link" />
					<Typography.Span textDecoration="underline" textColor="body">
						Include personal message?
					</Typography.Span>
				</Button>
				{isOpen && (
					<Button
						onClick={handleRemove}
						paddingRight="0"
						border="0"
						shadow="none"
						hoverShadow="none"
						textColor="link"
						visitedTextColor="link"
						backgroundColor="transparent"
					>
						Remove
					</Button>
				)}
			</Div>
			{isOpen && (
				<InputGroup elWidth="100%">
					<InputGroup.Fields padding="md">
						<InputGroup.Input
							as="textarea"
							onChange={handleMessageUpdate}
							rows="5"
							placeholder={placeholder}
							maxLength={maxLength}
							display="block"
							elWidth="100%"
							style={{ resize: 'none' }}
						/>
					</InputGroup.Fields>
					<Typography.Span
						as="small"
						textColor={message.length === maxLength ? 'danger' : 'ambientDark'}
					>
						{message.length}/{maxLength} characters
					</Typography.Span>
				</InputGroup>
			)}
		</>
	);
};
